import Developer from './developer';

export const developer = {
  firstLevel: Developer,
};